import {
  FaFacebookF,
  FaLinkedinIn,
  FaWhatsapp,
  FaTwitter,
} from "react-icons/fa";

const BlogContent = ({ blog }) => {
  return (
    <section className="py-24 bg-white">
      <div className="container-custom">

        <div className="max-w-4xl mx-auto">

          <img
            src={blog.image}
            alt={blog.title}
            className="w-full rounded-3xl shadow-xl mb-12"
          />

          <div className="prose prose-lg max-w-none">

            {blog.content.map((section, index) => (
              <div
                key={index}
                className="mb-12"
              >

                <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                  {section.heading}
                </h2>

                <p className="text-gray-600 leading-9 text-lg">
                  {section.text}
                </p>

              </div>
            ))}

          </div>

          {/* Tags */}

          <div className="border-t border-b border-gray-200 py-8 mt-16">

            <div className="flex flex-wrap justify-between gap-6">

              <div>

                <h4 className="font-semibold text-[#082B57] mb-3">
                  Category
                </h4>

                <span className="bg-[#F59E0B]/10 text-[#F59E0B] px-4 py-2 rounded-full">
                  {blog.category}
                </span>

              </div>

              <div>

                <h4 className="font-semibold text-[#082B57] mb-3">
                  Share Article
                </h4>

                <div className="flex gap-3">

                  <button className="w-10 h-10 rounded-full bg-[#082B57] text-white flex items-center justify-center">
                    <FaFacebookF />
                  </button>

                  <button className="w-10 h-10 rounded-full bg-[#082B57] text-white flex items-center justify-center">
                    <FaTwitter />
                  </button>

                  <button className="w-10 h-10 rounded-full bg-[#082B57] text-white flex items-center justify-center">
                    <FaLinkedinIn />
                  </button>

                  <button className="w-10 h-10 rounded-full bg-green-500 text-white flex items-center justify-center">
                    <FaWhatsapp />
                  </button>

                </div>

              </div>

            </div>

          </div>

          {/* Author Box */}

          <div className="bg-slate-50 rounded-3xl p-8 mt-12">

            <h3 className="text-2xl font-bold text-[#082B57]">
              About The Author
            </h3>

            <p className="text-gray-600 mt-4 leading-8">
              {blog.author} is part of the AZ Construction team,
              sharing industry insights, construction expertise,
              property investment tips and development trends.
            </p>

          </div>

        </div>

      </div>
    </section>
  );
};

export default BlogContent;